import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/webhook/beam-replay`;

// from / to: Bangkok dates 'YYYY-MM-DD', both inclusive
const getPending = async ({ from, to } = {}) => {
  return await axios.get(`${API_URL}/pending`, { params: { from, to } });
};

const replay = async (beamPurchaseId) => {
  return await axios.post(API_URL, { beamPurchaseId });
};

export default {
  getPending,
  replay,
};
